// import React from "react";

// function Loader() {
//   return <span class="loader"></span>;
// }

// export default Loader;
// import React from "react";
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useAuthContext } from "react-oauth2-code-pkce";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../store/authstore";

function LoaderFrappe() {
  const navigate = useNavigate();
  const { login, token, loginInProgress, error } = useAuthContext();
  const setToken = useAuthStore((state) => state.setToken);

  useEffect(() => {
    if (token && !loginInProgress) {
      setToken(token); // Save token to Zustand store
      navigate("/home", { replace: true });
    }
  }, [token, loginInProgress, navigate]);
  return createPortal(
    <div className="overlay">
      <span className="loader"></span>;
    </div>,
    document.body,
  );
}

export default LoaderFrappe;
